import axios from "axios";
import config from "../config";

export const CSRF_TOKEN_KEY = "csrfToken";

export const getCsrfToken = () => {
  if (typeof window === "undefined") return null;
  return sessionStorage.getItem(CSRF_TOKEN_KEY);
};

export const setCsrfToken = (token) => {
  if (typeof window === "undefined") return;
  if (!token) {
    sessionStorage.removeItem(CSRF_TOKEN_KEY);
    return;
  }
  sessionStorage.setItem(CSRF_TOKEN_KEY, token);
};

export const clearAuthSession = () => setCsrfToken("");

const api = axios.create({
  baseURL: config.apiUrl,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      config.headers = config.headers || {};
      if (!config.headers["X-CSRF-TOKEN"]) {
        config.headers["X-CSRF-TOKEN"] = csrfToken;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAuthSession();
    }
    return Promise.reject(error);
  }
);

export default api;
